import React, {useContext, useState} from 'react';
import {Button, TextField, Typography, Divider} from '@material-ui/core';
import {ApplicationContext} from '../context/ApplicationContext';
import {submitLogin} from '../services/login.service';
import {CircularProgress} from "@mui/material";
import config from "../config";
import './Login.scss';

const demoUsername = 'jsmith';
const demoPassword = '12345678';

const LoginPage = () => {
    const AppContext = useContext(ApplicationContext);
    const [providedUsername, setUsername] = useState('');
    const [providedPassword, setPassword] = useState('');
    const [isWaitingOnServer, setIsWaitingOnServer] = useState(false);

    const submitForm = (username, password) => {
        setIsWaitingOnServer(true);
        submitLogin(username, password)
            .then((reply) => {
                if (reply && reply.requires_setup) {
                    // Redirect to 2FA setup page with username
                    const destination_page = `${config.uiBaseUrl}/setup2fa?username=${encodeURIComponent(reply.username)}`;
                    window.location.replace(destination_page);
                } else if (reply && reply.requires_2fa) {
                    // Redirect to 2FA verification page with username
                    const destination_page = `${config.uiBaseUrl}/verify2fa?username=${encodeURIComponent(reply.username)}`;
                    window.location.replace(destination_page);
                } 
                // else {
                //     // Normal login - redirect to dashboard
                //     const destination_page = `${config.uiBaseUrl}/instantAnalytics`
                //     window.location.replace(destination_page);
                // }
                setIsWaitingOnServer(false);
            })
            .catch((err) => {
                console.log(err);
                AppContext.handleError('Failed login.');
                setIsWaitingOnServer(false);
            });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && providedUsername && providedPassword && !isWaitingOnServer) {
            submitForm(providedUsername, providedPassword);
        }
    };

    if (isWaitingOnServer) {
        return (
            <div className="login-container">
                <div className="login-card loading-state">
                    <CircularProgress size={48} style={{color: '#ffffff', marginBottom: '24px'}}/>
                    <Typography variant="h6" className="primary-font" style={{fontWeight: 500}}>
                        Logging in...
                    </Typography>
                </div>
            </div>
        )
    }

    return (
        <div className="login-container">
            <div className="login-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>
            
            <div className="login-card">
                <div className="login-header">
                    <Typography 
                        variant="h3" 
                        className="login-title primary-font"
                        style={{
                            fontFamily: 'Cookie, cursive',
                            fontSize: '48px',
                            marginBottom: '8px',
                            background: 'linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.8) 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                        }}
                    >
                        Verdantime
                    </Typography>
                    <Typography variant="body2" className="secondary-font" style={{opacity: 0.7, marginBottom: '32px'}}>
                        Welcome back. Please sign in to continue.
                    </Typography>
                </div>

                <div className="login-form">
                    <TextField 
                        onChange={e => setUsername(e?.target?.value)}
                        onKeyDown={handleKeyDown}
                        label="Username" 
                        variant="outlined"
                        fullWidth
                        className="login-input"
                        autoComplete="username"
                        autoFocus
                        value={providedUsername}
                    />
                    
                    <TextField 
                        onChange={e => setPassword(e?.target?.value)}
                        onKeyDown={handleKeyDown}
                        label="Password" 
                        variant="outlined"
                        type="password"
                        fullWidth
                        className="login-input"
                        autoComplete="current-password"
                        style={{marginTop: '20px'}}
                        value={providedPassword}
                    />

                    <Button 
                        className="login-button primary-font"
                        onClick={() => submitForm(providedUsername, providedPassword)} 
                        disabled={isWaitingOnServer || !providedUsername || !providedPassword}
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        Sign In
                    </Button>
                </div>

                <div style={{display: 'flex', alignItems: 'center', margin: '32px 0'}}>
                    <Divider style={{flex: 1, opacity: 0.3}} />
                    <Typography variant="caption" className="secondary-font" style={{opacity: 0.6, padding: '0 16px', margin: 0}}>
                        OR
                    </Typography>
                    <Divider style={{flex: 1, opacity: 0.3}} />
                </div>

                <Button 
                    className="demo-button primary-font"
                    onClick={() => submitForm(demoUsername, demoPassword)} 
                    disabled={isWaitingOnServer}
                    variant="outlined"
                    fullWidth
                    size="large"
                >
                    Try Demo Account
                </Button>
            </div>
        </div>
    );
}

export default LoginPage;
